import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useUserStore from 'stores/user-store';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;

  handleCloseTokenExpiredDialog(): void;
}

const ExpirationDialog: React.FC<Props> = ({ open, handleCloseTokenExpiredDialog }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const togglePrompt = useUserStore((state) => state.togglePrompt);

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} maxWidth={'xs'} fullWidth={true}>
      <DialogContent className={classes.dialogContent}>
        <Typography className={classes.mainText}>{t('sessionExpired1')}</Typography>
        <Typography className={classes.subText}>{t('sessionExpired2')}</Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <PaiButton text={t('ok')} action={handleCloseTokenExpiredDialog} />
        <Button className={classes.button} onClick={() => togglePrompt(false)}>
          {t('later')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  dialogContent: {
    padding: '16px',
  },
  mainText: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginBottom: '16px',
    textAlign: 'center',
  },
  subText: {
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.greys.medium,
    textAlign: 'center',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: '4.5rem',
    marginRight: '32px',
  },
  dialogActions: {
    justifyContent: 'center',
    padding: '16px',
    position: 'relative',
  },
  button: {
    position: 'absolute',
    right: '16px',
    bottom: '16px',
    borderRadius: 0,
    fontSize: theme.typography.pxToRem(13),
    color: '#000',
    textDecoration: 'underline',
    lineHeight: 1,
    padding: '12px 8px',
    '&:hover': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  },
}));

export default ExpirationDialog;
